module.exports = __webpack_public_path__ + "static/media/SmartShop_6-346w.aa3bcb49.png";